// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const applin: PokeData = {
  "id": 840,
  "name": "applin",
  "height": 2,
  "weight": 5,
  "base_experience": 52,
  "types": [
    PokeType.GRASS,
    PokeType.DRAGON
  ],
  "api_moves": [
    "withdraw",
    "astonish"
  ],
  "moves": [
    "dragon-pulse",
    "dragon-claw",
    "razor-leaf",
    "dragon-rush",
    "branch-poke",
    "bullet-seed",
    "outrage",
    "scale-shot",
    "inner-spirit",
    "draco-meteor",
    "power-whip",
    "synthesis",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 442,
    "item": null,
    "species": [
      {
        "name": "applin",
        "order": 840,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "flapple",
        "order": 841,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "tart-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "appletun",
        "order": 842,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sweet-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dipplin",
        "order": 1013,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "syrupy-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hydrapple",
        "order": 1021,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 1011,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "syrup-bomb"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 20,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
